/*
 * File: button-group.ts
 * File Created: 2024-01-05 07:56:10
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:29:36
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from "../base-classes";

@Component
export default class ButtonGroup extends BaseComponent {
    @Prop({ type: Boolean, required: false })
    vertical?: boolean;
}
